import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=797e3d48&scoped=true&"
import script from "./AboutPage.vue?vue&type=script&lang=ts&"
export * from "./AboutPage.vue?vue&type=script&lang=ts&"
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=797e3d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e3d48",
  null
  
)

export default component.exports